import { jobProfileToolsDelete, jobProfileToolsGet } from "#job-profile/services/api"
import JobProfileItem from "../JobProfileItem"
import { JobProfileToolsFormDialog } from "./JobProfileToolsForm"

function JobProfileTools({ profileId, autoFetch, noEdit }) {
	const items = [
		{
			name: "tool_name",
			label: "Nombre",
		},
		{
			name: "tool_type",
			label: "Tipo",
		},
		{
			name: "tool_departamento_name",
			label: "Departamento",
		},
	]
	return (
		<JobProfileItem
			key="tools"
			{...{
				profileId,
				autoFetch,
				tableItems: items,
				apiGet: jobProfileToolsGet,
				apiDelete: jobProfileToolsDelete,
				name: "",
				messageDelete: (competence) => (
					<span>
						¿Está seguro de que desea eliminar la herramienta
						<strong> {competence.tool_name}</strong>?
					</span>
				),
				AddForm: JobProfileToolsFormDialog,
				excluded: "herramientas_trabajo",
				noEdit,
			}}
		/>
	)
}

export default JobProfileTools
